import styled, { keyframes } from "styled-components";
import { FiActivity } from "react-icons/fi";

const pulse = keyframes`
  0%, 100% {
    opacity: 0.5;
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Container = styled.main`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    #f0f9ff 0%,
    #f8fafc 55%,
    #ecfdf5 100%
  );
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  text-align: center;
`;

const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: #e0f2fe;
  color: #0284c7;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const Title = styled.h1`
  margin: 0;
  color: #1e293b;
  font-size: 1.25rem;
  font-weight: 700;
`;

const Message = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
`;

export default function LoadingScreen() {
  return (
    <Container>
      <Content>
        <IconWrapper>
          <FiActivity size={30} />
        </IconWrapper>

        <Title>Carregando o SisGecMed</Title>

        <Message>
          Estamos preparando seu ambiente de trabalho...
        </Message>
      </Content>
    </Container>
  );
}